(() => {
  const settings = window.kgGiftSettings;
  if (!settings || !settings.variantId) return;
  const root = window.Shopify?.routes?.root || '/';
  let queue = Promise.resolve();
  const managed = item => Number(item.variant_id) === settings.variantId && item.properties?._kg_auto_gift === 'true';
  const request = async (path, body) => {
    const response = await fetch(root + path, body ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)} : {});
    if (!response.ok) throw new Error('Gift cart request failed');
    return response.json();
  };
  async function sync(options = {}) {
    let cart = await request('cart.js');
    let sections = null;
    let changed = false;
    const extras = options.sections?.length ? {sections:options.sections,sections_url:window.location.pathname} : {};
    async function change(key, quantity) {
      const response = await request('cart/change.js', {id:key,quantity,...extras});
      sections = response.sections || sections;
      changed = true;
      cart = await request('cart.js');
    }
    let gifts = cart.items.filter(managed);
    const qualifies = cart.items.some(item => !managed(item) && Number(item.variant_id) !== settings.variantId && item.original_price > 0 && item.product_type !== 'singleton_gift');
    if (!qualifies) {
      for (const item of gifts) await change(item.key,0);
      return {cart,sections,changed};
    }
    for (const item of gifts.slice(1)) await change(item.key,0);
    gifts = cart.items.filter(managed);
    if (gifts[0] && gifts[0].quantity !== 1) await change(gifts[0].key,1);
    const otherFreeBrush = cart.items.some(item => !managed(item) && Number(item.variant_id) === settings.variantId && item.final_price === 0);
    if (!gifts.length && !otherFreeBrush && settings.available) {
      const response = await request('cart/add.js',{items:[{id:settings.variantId,quantity:1,properties:{_kg_auto_gift:'true'}}],...extras});
      sections = response.sections || sections;
      changed = true;
      cart = await request('cart.js');
    }
    for (const item of cart.items.filter(managed)) {
      if (item.final_line_price !== 0) await change(item.key,0);
    }
    return {cart,sections,changed};
  }
  window.kgGift = {
    ensure(options) {
      const operation = queue.then(() => sync(options)).catch(error => {console.warn('KG gift:',error.message);return null;});
      queue = operation.then(() => undefined);
      return operation;
    }
  };
  document.addEventListener('DOMContentLoaded',async () => {
    if (!settings.itemCount) return;
    const items = document.querySelector('cart-items,cart-drawer-items');
    const targets = items?.getSectionsToRender?.() || [{id:'cart-icon-bubble',section:'cart-icon-bubble',selector:'.shopify-section'}];
    const result = await window.kgGift.ensure({sections:targets.map(section => section.section)});
    if (!result?.changed || !result.sections) return;
    const parser = new DOMParser();
    for (const section of targets) {
      const source = result.sections[section.section];
      const target = document.getElementById(section.id);
      if (!source || !target) continue;
      const html = parser.parseFromString(source,'text/html').querySelector(section.selector);
      if (html) (target.querySelector(section.selector) || target).innerHTML = html.innerHTML;
    }
    for (const target of document.querySelectorAll('cart-items,#main-cart-footer,cart-drawer')) target.classList.toggle('is-empty',result.cart.item_count === 0);
  });
})();